// extracted by mini-css-extract-plugin
module.exports = {"component":"logotype_component__NxWQ2","inner":"logotype_inner__EKhBq","clickable":"logotype_clickable__wQ5YE"};